// src/hooks/usePermissions.js
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export const usePermissions = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('usePermissions must be used within an AuthProvider');
  }
  
  const { 
    user, 
    role, 
    permissions, 
    loading, 
    adminData,
    login, 
    logout, 
    hasPermission, 
    hasAnyPermission,
    hasAllPermissions,
    isSuperAdmin,
    roleName
  } = context;
  

  
  return {
    user,
    role,
    permissions,
    loading,
    adminData,
    login,
    logout,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isSuperAdmin,
    roleName,
    hasModuleAccess: (module) => {
      if (isSuperAdmin) return true;
      return permissions?.some(p => p.startsWith(module + '.')) || false;
    },
    userName: user?.name || adminData?.name || 'User',
    userEmail: user?.email || adminData?.email || '',
    userContact: user?.contact || adminData?.contact || '',
    userId: user?.id || adminData?.id || null,
  };
};

export default usePermissions;